// these correspond to the class names set in the root-asset index.css
export const HIDABLE_UI_ELEMENT_CLASS_NAME = 'hideable';
function blockPropagationUntilVisible(
  e: React.PointerEvent<HTMLDivElement> | React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>,
) {
  const currentElement = e.currentTarget;

  if (!currentElement) return;

  if (parseInt(getComputedStyle(currentElement).opacity) < 1) {
    e.stopPropagation();
  }
}

export const nonEssentialElementProps = {
  className: HIDABLE_UI_ELEMENT_CLASS_NAME,
  onClickCapture: blockPropagationUntilVisible,
  onPointerDownCapture: blockPropagationUntilVisible,
  onPointerUpCapture: blockPropagationUntilVisible,
  onTouchStartCapture: blockPropagationUntilVisible,
  onTouchEndCapture: blockPropagationUntilVisible,
};
